module.exports = __webpack_public_path__ + "static/media/fail-csv.a9890196.svg";